import React, { Component } from 'react';
import Validator from 'validatorjs';

import EmisorFiscalCredentialsForm from './EmisorFiscalCredentialsForm';

class EmisorCsdFiscalCredentialsForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    const rules = {
      [`csd_key`]: ['required'],
      [`csd_cer`]: ['required'],
      [`csd_password`]: ['required', 'min:4']
    }

    this.state = {
      validator: new Validator({}, rules),
      rules
    };
  }

  get inputs() {
    return {
      key: {
        name: 'csd_key',
        label: 'CSD .key'
      },
      cer: {
        name: 'csd_cer',
        label: 'CSD .cer'
      },
      password: {
        name: 'csd_password',
        label: 'Contraseña del CSD'
      }
    }
  }

  validate(data) {
    const validator = new Validator(data, this.state.rules);

    validator.check();

    this.setState({
      validator,
      isValid:  validator.passes()
    });

    return validator;
  }

  handleOnChange = (event) => {
    const data = {
      ...this.props.data,
      ...event.data
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid:  validator.passes()
    });
  }

  render() {
    const {  data } = this.props;

    return (
      <EmisorFiscalCredentialsForm
        type='CSD'
        data={ data || {} }
        inputs={ this.inputs }
        onFormDataChange={ this.handleOnChange }
      />
    )
  }
}

export default EmisorCsdFiscalCredentialsForm;